export default __webpack_public_path__ + "static/media/SKIPER.74ebc824.png";